
import { mapActions, mapState, mapGetters } from "vuex";
import PrinterIcon from "~/assets/images/printerIcon.svg";

export default {
  name: "AppReceiverPrint",
  computed: {
    ...mapState("restaurant", ["printers"])
  },
  data() {
    return {
      PrinterIcon
    };
  }
};
